import { Sun, Users, MapPin, Leaf } from "lucide-react";

const stats = [
  { icon: Sun, value: "10.000+", label: "Impianti stimati", color: "text-amber-400" },
  { icon: Users, value: "50+", label: "Partner certificati", color: "text-emerald-400" },
  { icon: MapPin, value: "20", label: "Regioni coperte", color: "text-blue-400" },
  { icon: Leaf, value: "15.000", label: "Tonnellate CO₂ risparmiate", color: "text-emerald-400" },
];

export const StatsSection = () => {
  return (
    <section className="relative py-16 overflow-hidden" data-testid="stats-section">
      <div className="absolute inset-0 bg-slate-900" />
      <div className="absolute inset-0 grain opacity-20" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className="text-center animate-fade-in-up"
              style={{ animationDelay: `${i * 100}ms` }}
              data-testid={`stat-item-${i}`}
            >
              <stat.icon className={`w-7 h-7 ${stat.color} mx-auto mb-3`} strokeWidth={1.5} />
              <div
                className="text-3xl sm:text-4xl font-bold text-white mb-1"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {stat.value}
              </div>
              <div className="text-sm text-slate-400">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
